export enum PublisherType {
  organization = 'Business',
  individual = 'Individual',
}
